export default __webpack_public_path__ + "static/media/877.486eb374.gif";